<template>
  <div>
    <dialog-v2
      :show="show"
      title="Agregar configuración"
      @close="$emit('close')"
      @save="save">
      <template v-if="show" slot="content">
        <v-layout row wrap mb-3>
          <v-flex text-xs-center>
            <p class="text-xs-left">
              Seleccione los días de la semana para esta configuración:
            </p>
            <v-btn
              v-for="day in weekDays"
              :key="`button-${day.value}`"
              :class="{'daily-button': true, 'k-orange-linear': form.week_days.includes(day.value)}"
              @click="commuteWeekDay(day)"
              small
              fab
              flat
              :ripple="false">
              {{ day.text }}
            </v-btn>
          </v-flex>
        </v-layout>
        <v-tabs
          v-model="selectedTab"
          grow>
          <v-tabs-slider color="k-orange-linear" />
          <v-tab>
            Orden
          </v-tab>
          <v-tab>
            Orden secundario
          </v-tab>
          <v-tab>
            Limites
          </v-tab>
          <v-tab>
            Horario
          </v-tab>
          <v-tab>
            Prioridad
          </v-tab>
          <v-tab>
            Avanzado
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="selectedTab">
          <v-tab-item>
            <v-subheader class="pl-0">
              Programación fija
            </v-subheader>
            <draggable
              v-model="channelsList1"
              class="draggable-list"
              ghost-class="ghost"
              handle=".handle"
              group="channels"
              @change="fixedChanged">
              <template v-if="channelsList1.length">
                <v-layout
                  v-for="(channel, i) in channelsList1"
                  :key="`fixed-${i}`"
                  row
                  wrap
                  justify-between
                  align-center
                  :style="{ pointerEvents: !canEditWhatsappWorkflow && channel.name === 'whatsapp' ? 'none': 'auto' }"
                  :pt-3="i"
                  :pb-3="i === (channelsList1.length - 1)">
                  <v-flex xs1 text-xs-center pt-1>
                    <h4>
                      {{ i + 1 }}
                    </h4>
                  </v-flex>
                  <v-flex xs1 text-xs-center>
                    <v-icon class="k-orange-linear-text">
                      {{ channel.icon }}
                    </v-icon>
                  </v-flex>
                  <v-flex xs3 pt-1 pl-2>
                    {{ channel.text }}
                  </v-flex>
                  <v-flex xs4 pt-1>
                    <v-select
                      v-model="form[channel.name].purse_limit"
                      placeholder="Limite de cartera"
                      color="black"
                      attach
                      :items="percentages"
                      :hide-details="true"
                      :disabled="!canEditWhatsappWorkflow && channel.name === 'whatsapp'"
                      autocomplete/>
                  </v-flex>
                  <v-flex xs1 offset-xs2 text-xs-right>
                    <v-icon class="handle">
                      fas fa-arrows-alt
                    </v-icon>
                  </v-flex>
                </v-layout>
              </template>
              <v-layout row wrap v-else py-2>
                <v-flex xs1 text-xs-center>
                  <v-icon small>
                    fas fa-info-circle
                  </v-icon>
                </v-flex>
                <v-flex class="ml-3">
                  No hay canales que mostrar
                </v-flex>
              </v-layout>
            </draggable>
            <v-subheader class="pl-0">
              Inteligencia artificial
            </v-subheader>
            <draggable
              :list="channelsList2"
              class="draggable-list"
              ghost-class="ghost"
              handle=".handle"
              group="channels">
              <template v-if="channelsList2.length">
                <v-layout
                  v-for="(channel, i) in channelsList2"
                  :key="`ia-${i}`"
                  :style="{ pointerEvents: !canEditWhatsappWorkflow && channel.name === 'whatsapp' ? 'none': 'auto' }"
                  row wrap justify-between align-center pb-4 :pt-2="!i">
                  <v-flex xs1 text-xs-center>
                    <v-icon class="k-orange-linear-text">
                      {{ channel.icon }}
                    </v-icon>
                  </v-flex>
                  <v-flex pt-1 pl-2>
                    {{ channel.text }}
                  </v-flex>
                  <v-flex xs1 offset-xs3 text-xs-right>
                    <v-icon class="handle">
                      fas fa-arrows-alt
                    </v-icon>
                  </v-flex>
                </v-layout>
              </template>
              <v-layout row wrap v-else py-2>
                <v-flex xs1 text-xs-center>
                  <v-icon small>
                    fas fa-info-circle
                  </v-icon>
                </v-flex>
                <v-flex class="ml-3">
                  No hay canales que mostrar
                </v-flex>
              </v-layout>
            </draggable>
            <p class="mt-3 mb-0">
              Arrastre los canales para ajustar el orden de asignación
            </p>
          </v-tab-item>
          <v-tab-item>
            <v-subheader class="pl-0">
              Programación fija
            </v-subheader>
            <draggable
              v-model="channelsList1Secondary"
              class="draggable-list"
              ghost-class="ghost"
              handle=".handle"
              group="channels-secondary"
              @change="secondaryFixedChanged">
              <template v-if="channelsList1Secondary.length">
                <v-layout
                  v-for="(channel, i) in channelsList1Secondary"
                  :key="`fixed-secondary-${i}`"
                  row
                  wrap
                  justify-between
                  align-center
                  :style="{ pointerEvents: !canEditWhatsappWorkflow && channel.name === 'whatsapp' ? 'none': 'auto' }"
                  :pt-3="i"
                  :pb-3="i === (channelsList1Secondary.length - 1)">
                  <v-flex xs1 text-xs-center pt-1>
                    <h4>
                      {{ i + 1 }}
                    </h4>
                  </v-flex>
                  <v-flex xs1 text-xs-center>
                    <v-icon class="k-orange-linear-text">
                      {{ channel.icon }}
                    </v-icon>
                  </v-flex>
                  <v-flex xs3 pt-1 pl-2>
                    {{ channel.text }}
                  </v-flex>
                  <v-flex xs4 pt-1>
                    <v-select
                      v-model="form[channel.name].purse_limit"
                      placeholder="Limite de cartera"
                      color="black"
                      :items="percentages"
                      :hide-details="true"
                      :disabled="!canEditWhatsappWorkflow && channel.name === 'whatsapp'"
                      autocomplete/>
                  </v-flex>
                  <v-flex xs1 offset-xs2 text-xs-right>
                    <v-icon class="handle">
                      fas fa-arrows-alt
                    </v-icon>
                  </v-flex>
                </v-layout>
              </template>
              <v-layout row wrap v-else py-2>
                <v-flex xs1 text-xs-center>
                  <v-icon small>
                    fas fa-info-circle
                  </v-icon>
                </v-flex>
                <v-flex class="ml-3">
                  No hay canales que mostrar
                </v-flex>
              </v-layout>
            </draggable>
            <v-subheader class="pl-0">
              Inteligencia artificial
            </v-subheader>
            <draggable
              :list="channelsList2Secondary"
              class="draggable-list"
              ghost-class="ghost"
              handle=".handle"
              group="channels-secondary">
              <template v-if="channelsList2Secondary.length">
                <v-layout
                  v-for="(channel, i) in channelsList2Secondary"
                  :key="`ia-secondary-${i}`"
                  :style="{ pointerEvents: !canEditWhatsappWorkflow && channel.name === 'whatsapp' ? 'none': 'auto' }"
                  row wrap justify-between align-center pb-4 :pt-2="!i">
                  <v-flex xs1 text-xs-center>
                    <v-icon class="k-orange-linear-text">
                      {{ channel.icon }}
                    </v-icon>
                  </v-flex>
                  <v-flex pt-1 pl-2>
                    {{ channel.text }}
                  </v-flex>
                  <v-flex xs1 offset-xs3 text-xs-right>
                    <v-icon class="handle">
                      fas fa-arrows-alt
                    </v-icon>
                  </v-flex>
                </v-layout>
              </template>
              <v-layout row wrap v-else py-2>
                <v-flex xs1 text-xs-center>
                  <v-icon small>
                    fas fa-info-circle
                  </v-icon>
                </v-flex>
                <v-flex class="ml-3">
                  No hay canales que mostrar
                </v-flex>
              </v-layout>
            </draggable>
            <p class="mt-3 mb-0">
              Arrastre los canales para ajustar el orden de asignación secundario
            </p>
          </v-tab-item>
          <v-tab-item>
            <v-layout
              v-for="(channel, i) in orderedChannels"
              :key="`ia-${i}`"
              row wrap justify-between align-center py-3>
              <v-flex xs1 text-xs-center>
                <v-icon class="k-orange-linear-text">
                  {{ channel.icon }}
                </v-icon>
              </v-flex>
              <v-flex xs2 pt-1 pl-2>
                {{ channel.text }}
              </v-flex>
              <v-flex xs2 offset-md1>
                <v-text-field
                  v-model="form[channel.name].management_limit"
                  placeholder="Gestiones"
                  color="black"
                  :hide-details="true"
                  :disabled="!canEditWhatsappWorkflow && channel.name === 'whatsapp'"
                />
              </v-flex>
              <v-flex
                xs3
                offset-md1
                v-if="channel.name === 'human'">
                <v-text-field
                  v-model="form[channel.name].agent_limit"
                  placeholder="Por operador"
                  color="black"
                  :hide-details="true"/>
              </v-flex>
            </v-layout>
            <p class="mt-3 mb-0">
              Seleccione el número máximo de gestiones por canal.
            </p>
          </v-tab-item>
          <v-tab-item>
            <v-layout
              v-for="(channel, i) in orderedChannels"
              :key="`hour-${i}`"
              row wrap justify-between align-center py-3>
              <v-flex xs1 text-xs-center>
                <v-icon class="k-orange-linear-text">
                  {{ channel.icon }}
                </v-icon>
              </v-flex>
              <v-flex xs2 pt-1 pl-2>
                {{ channel.text }}
              </v-flex>
              <v-flex xs2 offset-md2>
                <v-select
                  v-model="form[channel.name].min_hour"
                  placeholder="Desde"
                  color="black"
                  :items="hours"
                  :hide-details="true"
                  :disabled="!canEditWhatsappWorkflow && channel.name === 'whatsapp'"
                  item-value="text"
                  autocomplete/>
              </v-flex>
              <v-flex xs2 offset-md2>
                <v-select
                  v-model="form[channel.name].max_hour"
                  placeholder="Hasta"
                  color="black"
                  :items="hours"
                  :hide-details="true"
                  :disabled="!canEditWhatsappWorkflow && channel.name === 'whatsapp'"
                  item-value="text"
                  autocomplete/>
              </v-flex>
            </v-layout>
            <p class="mt-3 mb-0">
              Seleccione el horario de gestión para cada canal.
            </p>
          </v-tab-item>
          <v-tab-item>
            <v-layout
              v-for="(channel, i) in orderedChannels"
              :key="`config-${i}`"
              row
              wrap
              justify-between
              align-center
              :pt-2="!i"
              :pt-3="i"
              :pb-3="i === (orderedChannels.length - 1)">
              <v-flex xs1 text-xs-center>
                <v-icon class="k-orange-linear-text">
                  {{ channel.icon }}
                </v-icon>
              </v-flex>
              <v-flex xs2 pt-1 pl-2>
                {{ channel.text }}
              </v-flex>
              <v-flex xs3 offset-md2>
                <v-text-field
                  v-model="form[channel.name].min_due_balance"
                  placeholder="Deuda minima"
                  color="black"
                  :hide-details="true"
                  :disabled="!canEditWhatsappWorkflow && channel.name === 'whatsapp'"
                />
              </v-flex>
              <v-flex text-xs-right>
                <v-tooltip bottom>
                  <v-btn 
                    icon 
                    slot="activator"
                    :disabled="!canEditWhatsappWorkflow && channel.name === 'whatsapp'"
                    @click.stop="openPriorityDialog(channel)" 
                  >
                    <v-icon small>
                      fas fa-sort-amount-up
                    </v-icon>
                  </v-btn>
                  <span>
                    Orden de asignación
                  </span>
                </v-tooltip>
              </v-flex>
            </v-layout>
            <p class="mt-3 mb-0">
              Ajuste la prioridad de asignacion para cada canal
            </p>
          </v-tab-item>
          <v-tab-item>
            <v-layout
              v-for="(channel, i) in humanChannels"
              :key="`config-${i}`"
              row
              wrap
              justify-between
              align-center
              :pt-2="!i"
              :pt-3="i"
              :pb-3="i === (humanChannels.length - 1)">
              <v-flex xs1 text-xs-center>
                <v-icon class="k-orange-linear-text">
                  {{ channel.icon }}
                </v-icon>
              </v-flex>
              <v-flex xs2 pt-1 pl-2>
                {{ channel.text }}
              </v-flex>
              <v-flex text-xs-right>
                <v-tooltip bottom>
                  <v-btn icon @click.stop="openMultipleManagementDialog(channel)" slot="activator">
                    <v-icon small>
                      fas fa-sort-amount-up
                    </v-icon>
                  </v-btn>
                  <span>
                    Gestión en paralelo
                  </span>
                </v-tooltip>
              </v-flex>
            </v-layout>
            <p class="mt-3 mb-0">
              Ajuste opciones especificas por canal.
            </p>
          </v-tab-item>
        </v-tabs-items>
      </template>
    </dialog-v2>
    <priority-dialog
      :show="priorityDialog"
      :data="priorityDialogData"
      :channel="selectedChannelText"
      @save="form[selectedChannel.name].assignment_order = $event"
      @close="priorityDialog = false"/>
    <multiple-management
      :show="multipleManagementDialog"
      :data="multipleManagementData"
      :channel="selectedChannelText"
      @save="form[selectedChannel.name].multiple_management = $event"
      @close="multipleManagementDialog = false"/>
  </div>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import Draggable from 'vuedraggable';
import { setTimeout } from 'timers';
import EventBus from '@/event-bus';
import PriorityDialog from '@/components/CollectWorkflows/PriorityDialog';
import MultipleManagement from '@/components/CollectWorkflows/MultipleManagementDialog';
import DialogV2 from '@/components/global/DialogV2';
import permissionsMixin from '@/mixins/permissions';

export default {
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    data: {
      type: Object,
      required: true,
    },
    isWhatsappOutboundActive: {
      type: Boolean,
      default: false,
    },
    dailyConfigManagementChannels: {
      type: Array,
      required: true,
    },
    dailyConfigEmptyForm: {
      type: Object,
      required: true,
    },
  },
  components: {
    Draggable,
    DialogV2,
    PriorityDialog,
    MultipleManagement,
  },
  mixins: [
    permissionsMixin,
  ],
  data() {
    const hours = [];
    for (let i = 0; i <= 23; i += 1) {
      for (let b = 0; b <= 1; b += 0.25) {
        hours.push({
          text: moment(i, 'HH').add(60 * b, 'minutes').format('HH:mm'),
        });
      }
    }
    const percentages = [];
    for (let i = 0; i <= 100; i += 10) {
      percentages.push({
        text: `${i}%`,
        value: i,
      });
    }
    return {
      selectedTab: '1',
      channelsList1: [],
      channelsList2: [],
      channelsList1Secondary: [],
      channelsList2Secondary: [],
      hours,
      percentages,
      weekDays: [
        {
          text: 'Lu',
          value: 1,
        },
        {
          text: 'Ma',
          value: 2,
        },
        {
          text: 'Mi',
          value: 3,
        },
        {
          text: 'Ju',
          value: 4,
        },
        {
          text: 'Vi',
          value: 5,
        },
        {
          text: 'Sa',
          value: 6,
        },
        {
          text: 'Do',
          value: 0,
        },
      ],
      selectedChannel: {},
      priorityDialog: false,
      multipleManagementDialog: false,
      priorityDialogData: {},
      multipleManagementData: {},
      form: _.cloneDeep(this.dailyConfigEmptyForm),
    };
  },
  computed: {
    orderedChannels() {
      return _.sortBy(this.dailyConfigManagementChannels, item => ((item.name === 'human') ? 1 : 2));
    },
    humanChannels() {
      return this.dailyConfigManagementChannels.filter(item => item.name === 'human');
    },
    secondaryOrderChannels() {
      return this.dailyConfigManagementChannels.filter(item => 
        ['sms', 'email', 'whatsapp'].includes(item.name)
      );
    },
    selectedChannelText() {
      return (this.selectedChannel.text || '').toLowerCase();
    },
    canEditWhatsappWorkflow() {
      return true;
      return this.checkPermissions([
        'edit_whatsapp_workflow',
      ]);
    },
  },
  methods: {
    fixedChanged() {
      this.dailyConfigManagementChannels.forEach((item) => {
        this.form[item.name] = {
          ...this.form[item.name],
          order: null,
        };
      });

      this.channelsList1.forEach((item, i) => {
        this.form[item.name] = {
          ...this.form[item.name],
          order: i,
        };
      });
    },
    secondaryFixedChanged() {
      this.secondaryOrderChannels.forEach((item) => {
        this.form[item.name] = {
          ...this.form[item.name],
          secondary_order: null,
        };
      });

      this.channelsList1Secondary.forEach((item, i) => {
        this.form[item.name] = {
          ...this.form[item.name],
          secondary_order: i,
        };
      });
    },
    commuteWeekDay(day) {
      const tmp = [
        ...this.form.week_days,
      ];
      const index = tmp.findIndex(item => item === day.value);
      if (index !== -1) {
        tmp.splice(index, 1);
      } else {
        tmp.push(day.value);
      }
      tmp.sort();
      this.form.week_days = [
        ...tmp,
      ];
    },
    openPriorityDialog(channel) {
      this.selectedChannel = channel;
      this.priorityDialogData = this.form[channel.name].assignment_order;
      this.priorityDialog = true;
    },
    openMultipleManagementDialog(channel) {
      this.selectedChannel = channel;
      this.multipleManagementData = this.form[channel.name].multiple_management;
      this.multipleManagementDialog = true;
    },
    save() {
      let error = false;
      if (!this.form.week_days.length) {
        error = true;
        EventBus.$emit('modal', 'Debe seleccionar al menos un día de la semana');
      }

      for (let i = 0; i < this.dailyConfigManagementChannels.length; i += 1) {
        const channel = this.dailyConfigManagementChannels[i].name;
        if (!this.form[channel].min_hour || !this.form[channel].max_hour) {
          error = true;
          EventBus.$emit('modal', 'Debe seleccionar un horario de gestión para todos los canales');
          break;
        } else if (this.form[channel].order !== null && this.form[channel].purse_limit === 0) {
          error = true;
          EventBus.$emit('modal', 'Debe seleccionar un limite para la programación fija');
          break;
        } else if (this.form[channel].secondary_order !== null && this.form[channel].secondary_order !== undefined && this.form[channel].purse_limit === 0) {
          error = true;
          EventBus.$emit('modal', 'Debe seleccionar un limite para la programación fija secundaria');
          break;
        }
      }

      if (!error) {
        this.$emit('save', this.form);
      }
    },
  },
  watch: {
    show() {
      if (this.show) {
        this.selectedTab = '0';
        this.channelsList2 = _.cloneDeep(this.dailyConfigManagementChannels);
        if (Object.keys(this.data).length) {
          this.form = _.cloneDeep(this.data);
          if (!this.form.whatsapp && this.isWhatsappOutboundActive) {
            // To avoid undefined errors with this new channel
            this.form.whatsapp = {
              order: null,
              secondary_order: null,
              purse_limit: null,
              management_limit: null,
              min_hour: null,
              max_hour: null,
              min_due_balance: null,
              assignment_order: {
                amount: null,
                delinquency: null,
              },
            };
          }
          // Initialize secondary_order if it doesn't exist
          this.secondaryOrderChannels.forEach((channel) => {
            if (this.form[channel.name] && (this.form[channel.name].secondary_order === undefined || this.form[channel.name].secondary_order === null)) {
              this.form[channel.name] = {
                ...this.form[channel.name],
                secondary_order: null,
              };
            }
          });
          // Initialize primary order channels
          let selectedChannels = _.sortBy(
            this.dailyConfigManagementChannels.filter(item => this.form[item.name] && this.form[item.name].order !== null),
            item => this.form[item.name].order,
          );
          this.channelsList1 = [
            ...selectedChannels,
          ];
          selectedChannels = this.channelsList1.map(item => item.name);
          this.channelsList2 = this.dailyConfigManagementChannels
            .filter(item => !selectedChannels.includes(item.name));
          // Initialize secondary order channels
          let selectedChannelsSecondary = _.sortBy(
            this.secondaryOrderChannels.filter(item => 
              this.form[item.name] && 
              this.form[item.name].secondary_order !== null && 
              this.form[item.name].secondary_order !== undefined
            ),
            item => this.form[item.name].secondary_order,
          );
          this.channelsList1Secondary = [
            ...selectedChannelsSecondary,
          ];
          selectedChannelsSecondary = this.channelsList1Secondary.map(item => item.name);
          this.channelsList2Secondary = this.secondaryOrderChannels
            .filter(item => !selectedChannelsSecondary.includes(item.name));
        } else {
          this.form = _.cloneDeep(this.dailyConfigEmptyForm);
          // Initialize secondary_order for secondary channels if it doesn't exist
          this.secondaryOrderChannels.forEach((channel) => {
            if (this.form[channel.name]) {
              this.form[channel.name] = {
                ...this.form[channel.name],
                secondary_order: null,
              };
            }
          });
          // Initialize secondary order channels in AI section by default
          this.channelsList2Secondary = _.cloneDeep(this.secondaryOrderChannels);
          this.channelsList1Secondary = [];
        }
      } else {
        setTimeout(() => {
          this.form = _.cloneDeep(this.dailyConfigEmptyForm);
          // Initialize secondary_order for secondary channels if it doesn't exist
          this.secondaryOrderChannels.forEach((channel) => {
            if (this.form[channel.name]) {
              this.form[channel.name] = {
                ...this.form[channel.name],
                secondary_order: null,
              };
            }
          });
          this.channelsList1 = [];
          this.channelsList2 = [
            ...this.dailyConfigManagementChannels,
          ];
          this.channelsList1Secondary = [];
          this.channelsList2Secondary = _.cloneDeep(this.secondaryOrderChannels);
        }, 200);
      }
    },
  },
};
</script>

<style scoped>
.draggable-list .ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
.draggable-list .handle:hover {
  cursor: pointer;
}
.input-group {
  padding-top: 0 !important;
}
.input-group >>> input {
  text-align: center !important;
}
.daily-button >>> .btn__content {
  background-color: #e0e0e0;
}
.daily-button.k-orange-linear >>> .btn__content {
  background-color: #ff7c64;
}
/* Fix dropdown z-index to appear above footer */
>>> .menuable__content__active {
  z-index: 300 !important;
}
>>> .v-menu__content {
  z-index: 300 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/CollectWorkflows/DailyDialog.vue